import { useNavigate } from "react-router-dom";
import { Button, useTheme, Box } from "@mui/material";
import { Avatar, Menu, MenuItem, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

export default function RoutesBtn({ nav }) {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState(10);

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      console.log("Decoded Token:", decodedToken);
      setUserRole(decodedToken.role);
    }
  }, [token]);

  const handleLoginLogoutClick = () => {
    if (token) {
      localStorage.removeItem("token");
      localStorage.removeItem("studentdata");
      localStorage.removeItem("userId");
      navigate("/");
    } else {
      navigate("/admin/login");
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    navigate("/admin/portal");
    if (userRole < 2) {
      navigate("/admin/portal");
    } else {
      navigate("/parents/portal");
    }
    handleMenuClose();
  };

  return (
    <>
      {token ? (
        <>
          <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
            <Avatar />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem onClick={handleProfileClick}>My Profile</MenuItem>
            <MenuItem onClick={handleLoginLogoutClick}>Logout</MenuItem>
          </Menu>
        </>
      ) : (
        ""
      )}
    </>
  );
}
